import * as _ from 'lodash';
import { CLOSE_SNACKBAR, ENQUEUE_SNACKBAR, REMOVE_SNACKBAR } from './constant';

const defaultState = {
  notifications: [],
  loadedAt: new Date().toJSON(),
};

const filterDuplicateMsg = (state, action) => {
  let { notifications = [] } = state;
  const notificationIndex = _.findIndex(
    notifications,
    (o) => o.message === action.notification.message,
  );

  if (notificationIndex < 0) {
    notifications = [
      ...state.notifications,
      {
        key: action.key,
        ...action.notification,
      },
    ];
  }

  return notifications;
};

export function Reducer(state = defaultState, action) {
  switch (action.type) {
    case ENQUEUE_SNACKBAR:
      return {
        ...state,
        notifications: filterDuplicateMsg(state, action),
      };

    case CLOSE_SNACKBAR:
      return {
        ...state,
        notifications: state.notifications.map((notification) =>
          action.dismissAll || notification.key === action.key
            ? { ...notification, dismissed: true }
            : { ...notification },
        ),
      };

    case REMOVE_SNACKBAR:
      return {
        ...state,
        notifications: state.notifications.filter(
          (notification) => notification.key !== action.key,
        ),
      };

    default:
      return state;
  }
}
